import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import KPSelectableList from '../../../BaseTemplate/SSPCustomComponentLibrary/KPSelectableList/KPSelectableList'
import { ISelectableListItem } from '../../../../interfaces/KPSelectableList/KPSelectableListInterfaces';
import './BuildingAge.css';
import { postToController } from '../../../../actions/apiActions';

class BuildingAge extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            items: [],
            selectedOption: this.props.sales.buildingAge ?? -1,
            submitted: false,
            nextDisabled: false
        };

        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleItemSelect = this.handleItemSelect.bind(this);
        this.getListDataSet = this.getListDataSet.bind(this);
    }

    componentWillMount() {
        this.getListDataSet();
        this.checkSubmit();
    }

    checkSubmit() {
        this.setState({ nextDisabled: !(this.state.selectedOption !== -1) });
    }

    async getListDataSet() {
        let dataSet: ISelectableListItem[] = [];

        await postToController(this.props.dispatch, 'GetHomeAges', JSON.stringify({})).then(async (response) => {
            response.forEach((item, index) => {
                dataSet.push({
                    id: item.id,
                    value: item.id,
                    label: item.description,
                    selected: (this.state.selectedOption === item.id),
                    required: false,
                    disabled: false,
                    handleSelect: null,
                    selectOnLeft: false,
                    className: ""
                } as ISelectableListItem);
            });
        });
        this.setState({ items: dataSet });
    }

    handleItemSelect(id: string, selected: boolean) {
        let item = this.state.items.filter(x => x.id === id)[0];
        let dataSet: ISelectableListItem[] = [];
        this.state.items.forEach((listItem, index) => {
            dataSet.push({
                id: listItem.id,
                value: listItem.id,
                label: listItem.description,
                selected: (item.value === listItem.id),
                required: false,
                disabled: false,
                handleSelect: null,
                selectOnLeft: false,
                className: ""
            } as ISelectableListItem);
        });
        this.setState({ selectedOption: item.value, items: dataSet }, () => this.checkSubmit());
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            this.props.dispatchAction(setQuoteData({ buildingAge: this.state.selectedOption }));
            await this.props.dispatchAction(handleNextStep());
        }
    }

    public render() {
        return (
            <div className="container">
                <div className="mt-4 text-center">
                    <p>How old is the home?</p>
                    <p>(You can find this on the title deed.)</p>
                </div>
                {this.state.items.length > 0 &&
                    <div className="row mt-4">
                        <div className="col-md-6 offset-md-3" style={{ textAlign: "left" }}>
                            <KPSelectableList
                                items={this.state.items}
                                handleSelect={this.handleItemSelect}
                                radioGroup={true}
                                autosize={true}
                            />
                        </div>
                    </div>
                }

                <div className="row mt-4">
                    <div className="col-12 justify-content-center mt-4">
                        <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuildingAge);